import React from "react";
import styles from "./css/ourbrands.module.css";

const Trending = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    cseEase: "linear",
    lazyLoad: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    swipeToSlide: true,
  };
  return (
    <>
      <section className={styles.ourBrandsMainContainer}>
        <div className="need-heading">
          <h2 className="text-center text-til my-3">OUR - BRAND CRISTELLO</h2>
        </div>
        <section className={styles.ourBrandsContainer}>
          <article>
            <section className={styles.ourBrandsImgContainer}>
              <img
                src="./assets/img/brands/first_img.jpeg"
                alt="Cristello Radiance Night Serum"
              />
            </section>
            <section className={styles.ourBrandsTextContainer}>
              <a
                target="_blank"
                href="https://cristello.in/collections/featured-product/products/cristello-radiance-night-serum-dullness-pigmentation-uneven-skin-texture"
              >
                {/* Skin Radiance Sunscreen Gel for Dry Skin 50gm */}
                <p>Cristello Radiance Night Serum For All Skin types....</p>
              </a>
              <p>
                <span className={styles.ourBrandsTextOldPrice}>₹599</span>
                <span className={styles.ourBrandsTextPrice}>₹539.10</span>
                <span className={styles.ourBrandsTextDicsount}>(10% OFF)</span>
              </p>
            </section>
          </article>
          <article>
            <section className={styles.ourBrandsImgContainer}>
              <img
                src="./assets/img/brands/second_img.jpeg"
                alt="Skin radiance sunscreen gel"
              />
            </section>
            <section className={styles.ourBrandsTextContainer}>
              <a
                target="_blank"
                href="https://cristello.in/collections/featured-product/products/cristello-skin-radiance-sunscreen-gel-spf-50-sun-damage-oiliness-uneven-tone"
              >
                <p>Skin Radiance Sunscreen Gel for Oily....</p>
              </a>
              <p>
                <span className={styles.ourBrandsTextOldPrice}>₹699</span>
                <span className={styles.ourBrandsTextPrice}>₹559.20</span>
                <span className={styles.ourBrandsTextDicsount}>(20% OFF)</span>
              </p>
            </section>
          </article>
        </section>
      </section>
    </>
  );
};
export default Trending;
